<template>
      <v-dialog v-model="dialog" :light="true" :dark="false"   persistent max-width="400">
      <v-card>
        <EncabezadoModal titulo="Confirmar" icono="mdi-help-circle-outline" :cerrable="false" />
        <v-card-text class="pt-4 text-body-1">{{text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close(false)" text >{{$t('Cancelar')}}</v-btn>
          <v-btn color="primary" @click="close(true)" text >{{$t('Aceptar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  
  export default {
    data(){
        return {
            dialog: true
        }
    },
    props: ['text', 'resolve'],
    methods: {
      close(accept){
          this.resolve(accept);
          this.$destroy(this.$el)
      }  
    }
  }
</script>
